type SpecsSection = 'hardware' | 'connectivity' | 'paymentExperience' | 'integration'

interface VariantSpec {
  deviceVariant?: string
  [key: string]: any
}

interface Specs {
  hardware?: VariantSpec[]
  connectivity?: VariantSpec[]
  paymentExperience?: VariantSpec[]
  integration?: VariantSpec[]
}
// @TODO add global data region type to `/core/types/mappers.ts`
interface Region {
  name: string
  sys: {
    id: string
  }
}
// @TODO add global data country type to `/core/types/mappers.ts`
interface Country {
  name: string
  region?: { sys: { id: string } }
}

interface RegionWithCountries {
  region: string
  countries: string
}

export const SPECS_SECTIONS: Readonly<SpecsSection[]> = Object.freeze([
  'hardware',
  'connectivity',
  'paymentExperience',
  'integration'
])

export const SPECS_SECTIONS_ICONS = {
  hardware: {
    category: 'products-24',
    name: 'solution-data'
  },
  connectivity: {
    category: 'products-24',
    name: 'plugins'
  },
  paymentExperience: {
    category: 'products-and-features',
    name: 'credit-card'
  },
  integration: {
    category: 'team',
    name: 'development-team'
  }
}

export const hasVariants = (specs: Specs): boolean => {
  return (specs?.hardware?.length ?? 0) > 1
}

export const getSectionsWithVariants = (specs: Specs): string[] => {
  return hasVariants(specs)
    ? SPECS_SECTIONS.flatMap((section) => {
        const sectionKey = section as keyof Specs
        return specs[sectionKey] && specs[sectionKey].length > 1
          ? specs[sectionKey].map((variantSpec) =>
              variantSpec.deviceVariant ? `${section}==${variantSpec.deviceVariant}` : section
            )
          : [section]
      })
    : [...SPECS_SECTIONS]
}

export const mapCountriesPerRegion = (regions: Region[], countries: Country[]): RegionWithCountries[] => {
  return regions
    .map((region) => {
      const regionName = region.name
      const filteredCountries =
        countries
          ?.filter((item) => item?.region?.sys?.id === region.sys.id)
          ?.map((item) => item.name)
          ?.join(', ') || ''
      return {
        region: regionName,
        countries: filteredCountries
      }
    })
    .filter((item) => !(item.countries.length < 1))
}
